import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import FactorInput from './FactorInput'
import Slider from '../../../Slider'
import sliders from '../../../../templates/sliders'
import ItemHeader from '../ItemHeader'
import S3Downloads from './S3Downloads'
import { toNameCase } from '../../../../utils'
import { CalculatorContext } from '../../../Context/CalculatorContext'

const sliderTypes = {
    LOW: 'low',
    STANDARD: 'standard',
    HIGH: 'high',
    CUSTOM: 'custom',
    AVERAGE_MEDIA_LENGTH: 'averageMediaLength'
}

const MboxItem = ({
    complexity,
    factor,
    profiles,
    remove,
    onChange,
    avgLength,
    value,
    s3Downloads,
    bitrate
}) => {
    const { tooltips } = useContext(CalculatorContext)

    return (
        <div>
            <ItemHeader
                title={`M-Box - ${toNameCase(complexity)}`}
                tooltip={tooltips[`mbox${toNameCase(complexity)}`]}
                remove={remove}
            >
                {complexity === sliderTypes.CUSTOM ? (
                    <FactorInput
                        factor={factor}
                        setFactor={(value) =>
                            onChange((item) => (item.factor = value))
                        }
                    />
                ) : null}
            </ItemHeader>

            <Slider
                {...sliders.averageMediaLength}
                value={avgLength}
                onChange={(value) =>
                    onChange((item) => (item.avgLength = value))
                }
            />

            <Slider
                {...sliders.mbox[complexity]}
                tooltip=""
                value={value}
                onChange={(value) => onChange((item) => (item.value = value))}
            />

            <Slider
                {...sliders.profiles}
                value={profiles}
                onChange={(value) =>
                    onChange((item) => (item.profiles = value))
                }
            />

            <S3Downloads
                s3Downloads={s3Downloads}
                onChange={onChange}
                bitrate={bitrate}
            />
        </div>
    )
}

MboxItem.propTypes = {
    complexity: PropTypes.string.isRequired,
    factor: PropTypes.number,
    profiles: PropTypes.number.isRequired,
    remove: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    avgLength: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
}

export default MboxItem
